import { px2rem } from '@/utils/utils'

export default {
  computed: {
    positionContent() {
      let content = {
        top: 'unset',
        left: 'unset',
        right: 'unset',
        bottom: 'unset'
      }
      if (this.props._layout === 'fixed') {
        const { position, top, left, right, bottom } = this.props.layoutDetail
        switch (position) {
          case 'center':
            content.top = '50%'
            content.left = '50%'
            content.transform = 'translate(-50%, -50%)'
            break
          case 'topLeft':
            content.top = px2rem(top, 0)
            content.left = px2rem(left, 0)
            break
          case 'topRight':
            content.top = px2rem(top, 0)
            content.right = px2rem(right, 0)
            break
          case 'bottomLeft':
            content.bottom = px2rem(bottom, 0)
            content.left = px2rem(left, 0)
            break
          case 'bottomRight':
            content.bottom = px2rem(bottom, 0)
            content.right = px2rem(right, 0)
            break
        }
      }
      return content
    }
  }
}
